/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  display: flex;
  /* border: 1px solid red; */
  align-items: center;
  background: ${Palette.PrimaryGray._000};
  padding: 0px 0px;
  ${({ withShadow }) =>
    withShadow &&
    css`
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04) inset;
    `};
`;
